import { setMetadata, setProducts, setTotals } from 'Store/actions/AppActions';
import { MetadataParams } from 'App/resources/AllIWant';
import type Product from 'App/resources/Model/Product';
import { replaceItem } from 'Store/helpers/array';
import store from 'App/babel/store/index';

const wrapAction = <T>(action: Function, data: T) => store.dispatch(action(data));

export const setClientParam = <T extends keyof MetadataParams>(name: T, value: MetadataParams[T]) => {
	const { metadata } = store.getState().App;

	if (metadata) {
		wrapAction(setMetadata, {
			...metadata,
			params: {
				...metadata.params,
				[name]: value
			}
		});
	}
};

const getUpdatedProductBundles = (products: Product[], relatedBundles: Product[]) => {
	return products.map(product => {
		const bundle = relatedBundles.find((bundle: Product) => bundle.id === product.id);
		return bundle || product;
	});
};

export const updateProduct = async (updatedProduct: Product | number, relatedBundles?: Product[]) => {
	const { products, totals } = store.getState().App;

	let newProducts = products;
	// Delete product
	if (typeof updatedProduct === 'number') {
		newProducts = products.filter(p => p.id !== updatedProduct);
	} else {
		const i = products.findIndex(p => p.id === updatedProduct.id);

		// Update product
		if (i !== -1) {
			newProducts = replaceItem(products, i, updatedProduct);
			if (relatedBundles) {
				newProducts = getUpdatedProductBundles(newProducts, relatedBundles);
			}
		} else {
			// Add product
			newProducts = [...products, updatedProduct];
		}
	}

	wrapAction(setTotals, { ...totals, products: newProducts.length });
	wrapAction(setProducts, newProducts);
};
